Namespace 'Customer.Tabs'

class Customer.Tabs.TabListView extends Backbone.View
  initialize: (@options = {}) ->
    @tabViews = @options.tabViews || throw new Error('Cannot instantiate a TabListView without tabViews')
    @scrollingView = new Customer.Tabs.TabScrollingView()
    @newCaseView = @options.newCaseView

  render: ->
    @$el.empty()
    @stopListening()
    @$el.parent().append @scrollingView.render().el
    @scrollingView.setScrollableElement(@$el)
    _.each @tabViews, (tabView) =>
      @$el.append(tabView.render().el)
      @listenTo(tabView, 'selected:tab', @onSelectTab)
      @listenTo(tabView, 'closed:tab', @onCloseTab)
      @listenTo(tabView, 'refresh:tab', @onRefreshTab)
    if @newCaseView?
      @$el.append @newCaseView.render().el
      @newCaseView.delegateEvents()
    @

  onSelectTab: (tabId, refresh=false) ->
    selectedTab = 'tabIdNotFound'
    _.each(@tabViews, (tabView) =>
      if tabView.tabId() == tabId
        tabView.select()
        selectedTab = tabView
        @scrollingView.updateDisabledScrollButtons()
      else
        tabView.deselect()
    )
    @trigger('selected:tab', selectedTab.tabbableView, refresh)

  onCloseTab: (tabId) ->
    closedTabIndex = ''
    closedTab = ''
    _.each(@tabViews, (tabView, index) =>
      if tabView.tabId() == tabId
        closedTabIndex = index
        closedTab = tabView
    )
    if closedTab != ''
      @trigger('closed:tab', closedTab.tabbableView)
      @tabViews.splice(closedTabIndex, 1)
      closedTab.remove()
      newSelectedTab = @tabViews[closedTabIndex] || @tabViews[closedTabIndex - 1]
      @onSelectTab(newSelectedTab.tabId())
      @scrollingView.updateDisabledScrollButtons()

  onRefreshTab: (tabId) ->
    refreshedTab = 'tabIdNotFound'
    _.each(@tabViews, (tabView) =>
      if tabView.tabId() == tabId
        refreshedTab = tabView
    )
    @trigger('refresh:tab', refreshedTab.tabbableView)

  changeToTab: (tabView) ->
    presentTab = _.find(@tabViews, (tab) -> tab.tabId() == tabView.tabId())
    if presentTab
      @_deselectAll()
      presentTab.select()
    else
      @addTab(tabView)
    @scrollingView.scrollTo(tabView.$el)

  addTab: (newTabView) ->
    @_deselectAll() if newTabView.selected
    if (@tabViews.length < 20)
      @tabViews.push(newTabView)
    @render()

  getActiveTab: ->
    selectedTabs = _.filter(@tabViews, (tab) -> tab.selected)
    if selectedTabs.length != 1
      throw new Error('Inconsistent state: zero or more than one tab selected')
    selectedTabs[0]

  getActiveView: ->
    @getActiveTab().tabbableView

  hasTab: (tabId) ->
    _.any(@tabViews, (tabView) =>
      tabView.tabId() == tabId
    )

  tabView: (tabId) ->
    _.find(@tabViews, (tabView) =>
      tabView.tabId() == tabId
    )

  _totalWidth: ->
    $mainHeader = $('#main-header')
    mainWidth = $mainHeader.outerWidth(true)
    brandWidth = $mainHeader.find('#brand').outerWidth(true)
    menuWidth = $mainHeader.find('#menu').outerWidth(true)
    mainWidth - brandWidth - menuWidth

  _deselectAll: ->
    _.each(@tabViews, (tabView) -> tabView.deselect())

  _visibleTabViews: ->
    _.select @tabViews, (tabView) -> tabView.isVisible()
